import ReportModal from './container';

export default ReportModal;
